
import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import BillingSettings from '@/components/portfolio/settings/BillingSettings';
import MembersSettings from '@/components/portfolio/settings/MembersSettings';
import { 
  Business, 
  Budget, 
  BillingManager as BillingManagerData, 
  PaymentMethod, 
  DiscountCode, 
  BillingHistoryItem 
} from '@/components/portfolio/settings/billing/types';

interface BusinessTabContentProps {
  activeTab: string;
  billingData: {
    activeBusinesses: Business[];
    pausedBusinesses: Business[];
    managedBudgets: Budget[];
    availableCredits: number;
    promotionalDiscount: number;
    totalCharge: number;
    billingManager: BillingManagerData;
    paymentMethods: PaymentMethod[];
    selectedPaymentMethod: string;
    setSelectedPaymentMethod: (id: string) => void;
    discountCodes: DiscountCode[];
    billingHistory: BillingHistoryItem[];
    handleAddPaymentMethod: () => void;
    handleAddPromoCode: () => void;
    handleMakePrimary: (methodId: string) => void;
    handleChangeBillingManager: (userId: string) => void;
    formatCurrency: (amount: number) => string;
  };
}

const BusinessTabContent = ({
  activeTab,
  billingData
}: BusinessTabContentProps) => {
  return (
    <>
      <TabsContent value="billing" className="w-full overflow-x-hidden">
        <BillingSettings 
          activeBusinesses={billingData.activeBusinesses}
          pausedBusinesses={billingData.pausedBusinesses}
          managedBudgets={billingData.managedBudgets}
          availableCredits={billingData.availableCredits}
          promotionalDiscount={billingData.promotionalDiscount}
          totalCharge={billingData.totalCharge}
          billingManager={billingData.billingManager}
          paymentMethods={billingData.paymentMethods}
          selectedPaymentMethod={billingData.selectedPaymentMethod}
          setSelectedPaymentMethod={billingData.setSelectedPaymentMethod}
          discountCodes={billingData.discountCodes}
          billingHistory={billingData.billingHistory}
          handleAddPaymentMethod={billingData.handleAddPaymentMethod}
          handleAddPromoCode={billingData.handleAddPromoCode}
          handleMakePrimary={billingData.handleMakePrimary}
          handleChangeBillingManager={billingData.handleChangeBillingManager}
          formatCurrency={billingData.formatCurrency}
          isBusinessBilling={true}
        />
      </TabsContent>

      <TabsContent value="users" className="w-full">
        <MembersSettings source="business" />
      </TabsContent>
    </>
  );
};

export default BusinessTabContent;
